import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement> & { color?: string }) {
  const { height = 24, width = 24, color = "#505766" } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path d="M17.9534 9.204C18.2067 9.55925 18.3334 9.73692 18.3334 9.99984C18.3334 10.2628 18.2067 10.4404 17.9534 10.7957C16.8149 12.392 13.9077 15.8332 10 15.8332C6.09234 15.8332 3.1851 12.392 2.04672 10.7957C1.79336 10.4404 1.66669 10.2628 1.66669 9.99984C1.66669 9.73692 1.79336 9.55925 2.04672 9.204C3.1851 7.6077 6.09234 4.1665 10 4.1665C13.9077 4.1665 16.8149 7.6077 17.9534 9.204Z" stroke={color} strokeWidth="1.25" />
      <path d="M12.5 10C12.5 8.61925 11.3807 7.5 10 7.5C8.61925 7.5 7.5 8.61925 7.5 10C7.5 11.3807 8.61925 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z" stroke={color} strokeWidth="1.25" />
    </svg>
  )
}

export default SvgComponent
